import {createSlice, PayloadAction} from "@reduxjs/toolkit";


interface TenantState{
    elements: TenantElement[]
}

export interface TenantElement {
    _id: string,
    businessName: string;
    city: string;
    isActive: boolean;
}


const initialState: TenantState = {
    elements: []
}

export const Tenant = createSlice({
    name: "tenant",
    initialState,
    reducers: {

        getAllElement : (state) => {},
        getAllElementSuccess: (state, actions: PayloadAction<TenantElement[]>) => {
            state.elements = actions.payload
        },
        getAllElementError: (state) => {},

        saveElement: (state, action: PayloadAction<TenantElement>) => {},
        saveElementSuccess: (state, actions: PayloadAction<TenantElement>) => {
            state.elements.push(actions.payload)
        },
        saveElementError: (state, action:PayloadAction<TenantElement>) => {},

        updateElement: (state, actions: PayloadAction<TenantElement>) => {},
        updateElementSuccess: (state, actions: PayloadAction<TenantElement>) => {
            let index = state.elements.findIndex(element => element.businessName === actions.payload.businessName)
            state.elements[index] = actions.payload
        },
        updateElementError: () => {},

        deleteElement: (state, action: PayloadAction<string>) => {},
        deleteElementSuccess: (state, action: PayloadAction<string>) => {},
        deleteElementError: (state) => {},
    }
})

export const {
    getAllElement,
    getAllElementSuccess,
    getAllElementError,
    saveElement,
    saveElementSuccess,
    saveElementError,
    updateElement,
    updateElementSuccess,
    updateElementError,
    deleteElement,
    deleteElementSuccess,
    deleteElementError
} = Tenant.actions

export default Tenant.reducer